import { baseUrl_V2 } from "src/utils/config";
import { goalBasedApi } from "../Goal-Based/goalBasedApi";

export const BankAccountsApi = goalBasedApi.injectEndpoints({
  endpoints: (builder) => ({
    getBankAccounts: builder.query({
      query: () => ({
        url: `/bankaccounts`,
        method: "GET",
      }),
      /* Five minutes, not the default sixty seconds. A reader who opens the
         withdraw dialog, closes it and opens it again is the ordinary case,
         and the list of their own bank accounts does not change between the
         two — but at the default the cache was gone and the dialog fetched
         from cold, which is what made it open on nothing. */
      keepUnusedDataFor: 300,
      transformResponse: (response: any) => {
        response.forEach((element) => {
          element.label = `${element.bankName} - ${element.iban}`;
          element.value = element._id;
          element.provider = element.provider || "manual";
        });
        return response;
      },
    }),
    getLeanCustomer: builder.query({
      query: () => ({
        url: `${baseUrl_V2}/dashboard/lean/customer`,
        method: "GET",
      }),
      providesTags: ["lean"]
    }),
    getLeanCustomerSources: builder.query({
      query: () => ({
        url: `${baseUrl_V2}/dashboard/lean/payments/sources`,
        method: "GET",
      }),
    }),
    payLeanIntents: builder.mutation({
      query: (payload) => {
        return {
          url: `${baseUrl_V2}/dashboard/lean/payments/intents`,
          method: "POST",
          body: payload,
        };
        
      },
      transformResponse: (response: { data }) => response.data,
    }),
  }),
});

export const { useGetBankAccountsQuery, useGetLeanCustomerQuery, useGetLeanCustomerSourcesQuery, usePayLeanIntentsMutation } = BankAccountsApi;
